import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
    import { useCustomerStore } from '@/store/customer';
    import { useGlobalStore } from '@/store/global';
    import { Country } from '@/enums/Country';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CalendlyWidget',
  setup(__props) {

    const globalStore = useGlobalStore();

    const customerStore = useCustomerStore();

    const openCalendlyModal = ref(false);

return { __sfc: true,globalStore, customerStore, openCalendlyModal, Country }
}

})